import * as Sentry from '@sentry/browser';
import Swal from 'sweetalert2'

// https://github.com/twbs/examples/blob/main/webpack/src/js/main.js
//
// Import our custom CSS
import '../scss/project.scss';
import '@xyflow/react/dist/style.css';
import 'handsontable/styles/handsontable.min.css';
import 'handsontable/styles/ht-theme-main.min.css';
import 'handsontable/styles/ht-theme-horizon.min.css';

// Import only the Bootstrap components we need
import {Popover} from 'bootstrap';

// tourguide js
import {TourGuideClient} from '@sjmc11/tourguidejs';

if (process.env.SENTRY_DSN) {
    const APP_VERSION = `${process.env.APP_VERSION}`
    Sentry.init({
        dsn: process.env.SENTRY_DSN,
        release: `${process.env.SENTRY_RELEASE_NAME}@${APP_VERSION}`,
        integrations: [Sentry.browserTracingIntegration()],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: process.env.SENTRY_TRACES_SAMPLE_RATE || 1.0,
        environment: process.env.SENTRY_RELEASE_NAME || 'production',
    });
}

// Create an example popover
document.querySelectorAll('[data-bs-toggle="popover"]')
    .forEach(popover => {
        new Popover(popover)
    })

document.addEventListener("htmx:confirm", (e) => {
    if (!e.detail.question) return
    e.preventDefault()
    const elt = e.detail.elt;
    const vals = JSON.parse(elt.getAttribute("hx-vals"));

    if (vals["object_list"]) {
        const checkedObjects = document.querySelectorAll(`input[name=${vals["object_list"]}]:checked`);
        if (checkedObjects.length === 0) {
            document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
            Swal.fire({
                icon: 'error',
                title: `Please select at least one ${vals["object_name"]}.`,
            });
            return
        }
    }
    if (!vals.type) {
        e.detail.issueRequest(true);
    } else if (vals.type === "confirm") {
        Swal.fire({
            title: `${e.detail.question}`,
            icon: 'warning',
            showCancelButton: true,
        }).then((result) => {
            if (result.isConfirmed) {
                e.detail.issueRequest(true);
            }
        })
    }
})

document.addEventListener("DOMContentLoaded", async () => {
    const selectAllCheckboxes = document.querySelectorAll('.select-all');

    selectAllCheckboxes.forEach((selectAll) => {
        selectAll.addEventListener('change', () => {
            const table = selectAll.closest('table');
            const checkboxes = table.querySelectorAll('.form-check-input');
            checkboxes.forEach((checkbox) => {
                checkbox.checked = selectAll.checked;
            });
        });
    });

    /*
    * Tourguide js
    * */
    const tourButton = document.getElementById('tourButton')
    const tourTriggerGroup = document.getElementById('tourTriggerGroup')
    const tourDataSteps = tourTriggerGroup?.dataset.tgSteps;

    if (tourDataSteps) {
        const tourGroup = tourTriggerGroup.dataset.tgName;
        const dataSteps = JSON.parse(tourDataSteps)
        const tourSteps = dataSteps.map(step => ({
            ...step,
            "group": tourGroup
        }))

        const tg = new TourGuideClient({
            completeOnFinish: true,
            dialogZ: 1100,
            backdropClass: "z-index-toast",
            exitOnClickOutside: false,
            steps: tourSteps
        });

        if (dataSteps.length) {
            tourButton.classList.remove("d-none");
            tourButton.addEventListener('click', e => {
                e.preventDefault();
                tg.start(tourGroup)
            })
        }
    }
})

document.addEventListener('change', function (e) {
    if (e.target.matches('table input[type="checkbox"]')) {
        const tr = e.target.closest('tr');
        if (tr) {
            tr.classList.toggle('table-active', e.target.checked);
        }
    }
});
